<div class="row d-flex justify-content-end">
    <a class="btn btn-sm btn-dark mr-5" [routerLink]="['/admin_panel/bucket_details']" routerLinkActive="router-link-active" >Back</a>
  </div>
  
  <div style="margin-right: 32px;">
    <div>
        <h4 class="title" style="margin-top: 15px;">Allocation</h4>
    </div>
  </div>
  

  
  <br>
  <div class="row">
    <div class="col-md-4">
      <h5 class="form-lable">Choose Designations</h5>
      <p-dropdown [options]="Designation_details1" (onChange)="fetchuser_1()" [(ngModel)]="report_to_design"
        placeholder="Report to Designations" optionLabel="y" [showClear]="true"></p-dropdown>
      </div>
      
      
      <div class="col-md-4">
      <h5 class="form-lable">Choose User Details</h5>
      <p-dropdown [options]="User_details1" (onChange)="Report_fetch()" [(ngModel)]="report_to"
        placeholder="Report to User Details" optionLabel="y" [showClear]="true"></p-dropdown>
      </div>

      <div class="col-md-4">
        <h5 class="form-lable">Select Expired Date</h5>
        <input type="date" [(ngModel)]="expired" name="expired">
        </div>
    
  </div>
  
  <div style="margin: 2px;padding-bottom: 15px;" >
  
    <div class="row">

       
            <div class="col-md-4">
                <h5 class="form-lable">Choose Bank:</h5>
                <p-dropdown [options]="Bank_list" name='Bank_list_gets' (onChange)="fetchuser_1()"  [(ngModel)]="Bank_list_gets" placeholder="Select" optionLabel="y"
                    [showClear]="true"></p-dropdown>
        
            </div>
            <div class="col-md-4">
                <h5 class="form-lable">Choose Portfolio:</h5>
                <p-dropdown [options]="portfolio_list" name='portfolio_list_gets'  [(ngModel)]="portfolio_list_gets" placeholder="Select" optionLabel="y"
                    [showClear]="true"></p-dropdown>
            </div>
            <div class="col-md-4">
                <h5 class="form-lable">Action : </h5>
                 <button>Filter</button>
            </div>
   
  
        <div class="col-md-12">
            <div>
            <h4 class="title-f" style="color: #0a2440;font-weight: 600;border-bottom: 2px solid;">Accounts Details</h4>
            <!-- <div *ngIf="loading" >
                <ag-grid-angular #agGrid
                    style="width: auto; height: 600px;"
                    class="ag-theme-alpine"
                    [rowData]="saved_Fields"
                    [rowSelection]="'multiple'"
                    [columnDefs]="AllocationcolumnDefs"
                    [pagination]="true">
                </ag-grid-angular>
            </div> -->
  
            <p> Not Allocated Account Details </p>
            <button *ngIf="skip_count !== 0" (click)="previous()">Previous  Records</button>
            <button (click)="next()">Next 200  Records</button>
            <div *ngIf="loading" >
                <ag-grid-angular #agGrid
                    style="width: auto; height: 600px;"
                    class="ag-theme-alpine"
                    [rowData]="saved_Fields_New"
                    [rowSelection]="'multiple'"
                    [columnDefs]="AllocationcolumnDefs"
                    [pagination]="true">
                </ag-grid-angular>
            </div>
  
            </div>
        </div>
    </div>
  </div>
  

  